module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email-logs-component"
  }, [(!_vm.isFetching) ? _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "items": _vm.logs,
      "fields": _vm.fields,
      "per-page": 5,
      "busy": _vm.isFetching,
      "empty-text": _vm.$t('emailLog.noMailSent')
    },
    scopedSlots: _vm._u([{
      key: "cell(subtype)",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(_vm.$t(("emailLog." + (row.item.type) + "." + (row.item.subtype)))))])]
      }
    }, {
      key: "cell(status)",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(_vm.$t(("emailLog.status." + (row.item.status)))))])]
      }
    }, {
      key: "cell(created_at)",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s((new Date(row.item.created_at)).toLocaleString()))])]
      }
    }, {
      key: "cell(actions)",
      fn: function(row) {
        return [_c('b-btn-group', {
          staticClass: "pull-right"
        }, [_c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "variant": "primary",
            "disabled": _vm.fetchingContent,
            "title": _vm.$t('emailLog.actions.seeContent')
          },
          on: {
            "click": function($event) {
              return _vm.getContent(row.item.id)
            }
          }
        }, [_c('fa-icon', {
          attrs: {
            "icon": "envelope-open",
            "fixed-width": ""
          }
        })], 1), _vm._v(" "), (row.item.attachment) ? _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "variant": "primary",
            "disabled": _vm.fetchingAttachment,
            "title": _vm.$t('emailLog.actions.downloadAttachment')
          },
          on: {
            "click": function($event) {
              return _vm.downloadAttachment(row.item)
            }
          }
        }, [_c('fa-icon', {
          attrs: {
            "icon": "file-pdf",
            "fixed-width": ""
          }
        })], 1) : _vm._e()], 1)]
      }
    }], null, false, 1457783005)
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-333bc885"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/EmailLogsComponent.vue
// module id = 1293
// module chunks = 1